// <color-swatches> — collection page image swap + product page variant trigger
if (!customElements.get('color-swatches')) {
  customElements.define('color-swatches', class ColorSwatches extends HTMLElement {
    connectedCallback() {
      this.context = this.dataset.context || 'product';
      this.querySelectorAll('button.color-swatch').forEach((btn) =>
        btn.addEventListener('click', this.onSwatchClick.bind(this))
      );
    }

    onSwatchClick(event) {
      const btn = event.currentTarget;
      if (btn.classList.contains('is-unavailable')) return;
      const value = btn.dataset.value;
      this.querySelectorAll('button.color-swatch').forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      if (this.context === 'collection') {
        this.updateCollectionImage(value);
      } else {
        this.selectVariantOption(btn);
      }
    }

    selectVariantOption(btn) {
      const optionName = btn.dataset.optionName;
      const optionPosition = btn.dataset.optionPosition;
      const value = btn.dataset.value;
      const inputName = `${optionName}-${optionPosition}`;
      const vs = document.querySelector('variant-selects');
      if (!vs) return;
      const radio = Array.from(vs.querySelectorAll('input[type="radio"]'))
        .find((el) => (el.name || '').trim() === inputName && el.value === value);
      if (radio && !radio.checked) { radio.click(); return; }
      const select = Array.from(vs.querySelectorAll('select'))
        .find((el) => el.name === `options[${optionName}]`);
      if (select && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateCollectionImage(value) {
      const mapEl = this.querySelector('[data-color-image-map]');
      if (!mapEl) return;
      let m; try { m = JSON.parse(mapEl.textContent); } catch (e) { return; }
      const url = m[value];
      if (!url) return;
      const card = this.closest('.card-wrapper');
      if (!card) return;
      const img = card.querySelector('.card__inner .card__media img');
      if (!img) return;
      img.src = url; img.srcset = url; img.alt = value;
    }
  });
}
